var _style, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgImpressions = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF0B3B;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M484.1,263.84l4.8-7.84l-4.8-7.84c-0.8-1.31-20.12-32.48-57.64-63.72c-49.9-41.54-108.69-63.5-170.02-63.5 c-61.31,0-120.24,21.95-170.43,63.47c-37.73,31.22-57.27,62.37-58.08,63.68l-4.9,7.91l4.9,7.91c0.81,1.31,20.34,32.46,58.08,63.68 c50.19,41.52,109.12,63.47,170.43,63.47c61.32,0,120.11-21.96,170.02-63.5C463.98,296.32,483.3,265.15,484.1,263.84z M406.47,305.16 c-44.89,37.09-95.37,55.9-150.02,55.9c-54.68,0-105.32-18.82-150.51-55.93c-23.38-19.2-39.22-38.63-46.98-49.13 c7.77-10.5,23.61-29.93,46.98-49.13c45.2-37.11,95.83-55.93,150.51-55.93c54.66,0,105.13,18.81,150.02,55.9 c23.27,19.23,38.98,38.69,46.64,49.16C445.45,266.48,429.74,285.94,406.47,305.16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,165.87c-49.7,0-90.13,40.43-90.13,90.13s40.43,90.13,90.13,90.13s90.13-40.43,90.13-90.13 S305.7,165.87,256,165.87z M256,316.13c-33.16,0-60.13-26.98-60.13-60.13s26.98-60.13,60.13-60.13s60.13,26.98,60.13,60.13 S289.16,316.13,256,316.13z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30,30h62.63V0H0v91.5h30V30z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M419.38,0v30H482v61.5h30V0H419.38z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30,420.5H0V512h92.63v-30H30V420.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M482,482h-62.63v30H512v-91.5h-30V482z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgImpressions, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/impressions.547fca09.svg";
export { ForwardRef as ReactComponent };